document.addEventListener('alpine:initialized', () => {
    const params = new URLSearchParams(window.location.search);

    const faqId = params.get('faq');
    if (faqId) {
        const el = document.getElementById('faq-' + faqId);
        if (el) {
            const data = Alpine.$data(el);
            if (data && typeof data.open !== 'undefined') {
                data.open = true;
                history.replaceState(null, '', window.location.pathname);
                setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 50);
            }
        }
    }

    const attractionId = params.get('attraction');
    if (attractionId) {
        window.__pendingAttraction = attractionId;
        history.replaceState(null, '', window.location.pathname);
    }
});

document.addEventListener("alpine:init", () => {
    Alpine.data("flyoutSearch", () => ({
        query: '',
        debounceTimer: null,
        results: {
            page: [],
            post: [],
            offer: [],
            add_on: [],
            hotel_room: [],
            apartment: [],
            activity: [],
            conference_offer: [],
            conference_room: [],
            faq: [],
            attraction: []
        },
        hasPages: false,
        hasPosts: false,
        hasOffers: false,
        hasAddOns: false,
        hasHotelRooms: false,
        hasApartments: false,
        hasActivities: false,
        hasConferenceOffers: false,
        hasConferenceRooms: false,
        hasFaqs: false,
        hasAttractions: false,
        loading: false,
        showResults: false,
        showNoResults: false,

        search() {
            clearTimeout(this.debounceTimer);
            this.debounceTimer = setTimeout(() => {
                this._doSearch();
            }, 300);
        },

        _doSearch() {
            if (this.query.trim().length < 2) {
                this.reset();
                return;
            }

            this.loading = true;

            fetch(flyoutSearchAjax.ajax_url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams({
                    action: 'flyout_search',
                    query: this.query.trim()
                })
            })
                .then(res => res.json())
                .then(data => {
                    this.loading = false;

                    const mapItems = key => (data[key] || []).map(item => ({
                        uid: item.uid,
                        id: item.id,
                        title: item.title,
                        permalink: item.permalink,
                        site_name: item.site_name
                    }));

                    this.results = {
                        page: mapItems('page'),
                        post: mapItems('post'),
                        offer: mapItems('offer'),
                        add_on: mapItems('add_on'),
                        hotel_room: mapItems('hotel_room'),
                        apartment: mapItems('apartment'),
                        activity: mapItems('activity'),
                        conference_offer: mapItems('conference_offer'),
                        conference_room: mapItems('conference_room'),
                        faq: mapItems('faq'),
                        attraction: mapItems('attraction')
                    };

                    this.hasPages = this.results.page.length > 0;
                    this.hasPosts = this.results.post.length > 0;
                    this.hasOffers = this.results.offer.length > 0;
                    this.hasAddOns = this.results.add_on.length > 0;
                    this.hasHotelRooms = this.results.hotel_room.length > 0;
                    this.hasApartments = this.results.apartment.length > 0;
                    this.hasActivities = this.results.activity.length > 0;
                    this.hasConferenceOffers = this.results.conference_offer.length > 0;
                    this.hasConferenceRooms = this.results.conference_room.length > 0;
                    this.hasFaqs = this.results.faq.length > 0;
                    this.hasAttractions = this.results.attraction.length > 0;

                    const hasAny = this.hasPages || this.hasPosts || this.hasOffers ||
                        this.hasAddOns || this.hasHotelRooms || this.hasApartments || this.hasActivities ||
                        this.hasConferenceOffers || this.hasConferenceRooms || this.hasFaqs ||
                        this.hasAttractions;

                    this.showResults = hasAny;
                    this.showNoResults = !hasAny;
                })
                .catch(err => {
                    console.error('Fetch error:', err);
                    this.loading = false;
                    this.reset();
                });
        },

        reset() {
            this.results = { page: [], post: [], offer: [], add_on: [], hotel_room: [], apartment: [], activity: [], conference_offer: [], conference_room: [], faq: [], attraction: [] };
            this.hasPages = this.hasPosts = this.hasOffers = this.hasAddOns = this.hasHotelRooms = this.hasApartments = this.hasActivities = this.hasConferenceOffers = this.hasConferenceRooms = this.hasFaqs = this.hasAttractions = false;
            this.showResults = this.showNoResults = false;
        },

        clearSearch() {
            this.query = '';
            this.results = { page: [], post: [], offer: [], add_on: [], hotel_room: [], apartment: [], activity: [], conference_offer: [], conference_room: [], faq: [], attraction: [] };
            this.showResults = false;
            this.showNoResults = false;
            this.loading = false;
        }
    }));
});

//# sourceMappingURL=flyout-search.js.map
